import React from 'react'
import { DataTable } from '../widgets'

const NetworkRow = (props) => {
    const { index, network, showSwap, handleSelectedFarm } = props;
    const formatFarmStatus = (farmItem, index) => {
        return <span key={index}
            className={`my-1 badge badge-pill ${farmItem.alive ? "badge-success" : "badge-secondary"} badge-sm mr-2`}>
            {farmItem.farm_name} - {farmItem.device_name}
        </span>
    };

    return (
        <DataTable.Row>
            <DataTable.Cell style={{ width: "60px" }}>{index}</DataTable.Cell>
            <DataTable.Cell style={{ width: "60px" }}>{network.name}</DataTable.Cell>
            <DataTable.Cell style={{ width: "60px" }}>  {network.network_history.length > 0 ? network.network_history.sort((a, b) => b.alive - a.alive)
                .map((farmItem, i) => formatFarmStatus(farmItem, i)) : 'N/A'}</DataTable.Cell>
            {/* <DataTable.Cell style={{ width: "60px" }}>{network.device_name ? network.device_name : "N/A"}</DataTable.Cell> */}
            <DataTable.Cell style={{ width: "60px" }}><i className="fa fa-cogs cursor-pointer" title="See Details" aria-hidden="true" onClick={() => handleSelectedFarm(!showSwap, network.device_uuid, network.network_type_id, network.network_uuid, network.network_history)}></i></DataTable.Cell>
        </DataTable.Row >
    )
}

export default NetworkRow;